import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {
    SMALL_TEXT_PX,LARGE_TEXT_PX,
    TITLE_FONT_COLOR,
    CURSOR
} from 'src/styles/fonts/MCFontConstants';

export const TemplateTitleContainer = styled.div.attrs((props) => ({
    id: props.id || 'setDetail-title-container',
}))`
    display: flex;
    flex-direction: row;
    margin: 4px 6px 10px 8px;
    justify-content: space-between;
    align-items: center;
    ${media.mobileDevice` 
        margin: 17px 16px 10px 16px;
        background: ${({ isCondensedView }) =>
            isCondensedView ? 'white' : 'transparent'};
        padding: ${({ padding }) => (padding ? padding : '0px')};
    `}
`;

export const TemplateContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 92%;
    overflow-y: hidden;
    overflow-x: hidden;
    background-color: white;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    padding: 0px 5px;
    padding-bottom: ${({ paddingBottom }) =>
        paddingBottom ? paddingBottom : '30px'};

    ${media.mobileDevice`
         box-shadow: ${({ isCondensedView }) =>
             isCondensedView ? 'none' : '0px 0px 6px #00000029'};
        overflow-y: hidden;
        overflow-x: unset;
       padding : ${({ mbPadding }) => (mbPadding ? '0px' : '14px')};
        border-radius: 6px;
        height:auto;
        width: ${({ width }) => (width ? width : '100%')};
        margin-bottom : 0px;
         position: relative;
        overflow: visible;
        margin : ${({ mbMargin }) => mbMargin};
    `}
`;
export const Divtest = styled.div`
    background-color: red;
    height: 30px;
    width: 30px;
`;
export const FooterContainer = styled.div`
    position: sticky;
    bottom: 0;
    ${media.mobileDevice`
        display: none;
    `}
`;
export const TemplateTitle = styled.div`
    letter-spacing: 0px;
    color: #130e4a;
    opacity: 1;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: ${LARGE_TEXT_PX};
    padding-left: 0px;
    width: 100%;
     ${media.mediumDevice`
    padding-left:${(isCondensedView) => (isCondensedView ? '30px' : '11px')};
    `}
    ${media.mobileDevice`
       padding-left: ${({ mbPaddingLeft }) =>
        mbPaddingLeft ? mbPaddingLeft : ''};
    `}
`;
export const LineSeparator = styled.hr`
    border: 0;
    border-top: ${(props) =>
        props.borderTop ? props.borderTop : '1px solid #f5f5f5'};
    box-sizing: content-box;
    height: 0;
    overflow: visible;
    width: ${(props) => (props.width ? props.width : '100%')};
    margin: ${(props) => (props.margin ? props.margin : '0px')};
    margin-bottom: 1%;
`;
export const Icon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: 18px;
    height: 18px;
    cursor: ${CURSOR};
    margin-right: ${({ marginRight }) =>
        marginRight ? marginRight : '12px'};
`;

export const SubItemCount = styled.div`
    margin-left: 50px;
    ${media.mobileDevice`

    `}
`;
export const StyledSortIcon = styled.div`
    width: 18px;
    height: 16px;
    margin: 8px;
    margin-right: 8px;
    margin-left: 8px;
    ${media.mobileDevice`
        //display: none;
    `}
`;
export const MainSectionFlex = styled.div`
    display: flex;
    margin: 12px 0 0 0;
    padding: 0 2px 0 3px;
    width: ${({ width }) => (width ? width : '100%')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
    ${media.mobileDevice`
    flex-direction:column;
    justify-content: space-between;
    /* margin-top: 20px; */
    margin: 0px;
    
    width: ${({ width }) => (width ? width : '100%')};
    padding : padding-right :4px;;
    `}
`;

export const MainSection = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 12px 0 0 0;
    padding: 0 2px 0 3px;
    ${media.mobileDevice`
    flex-direction:column;
    justify-content: space-between;
    /* margin-top: 20px; */
    margin: 0px;
    padding : 0;
    `}
`;
export const MainSegmentSection = styled.div.attrs((props) => ({
    id: props.id || 'setItemDetails-main-segment-section',
}))`
    display: flex;
    justify-content: space-between;
    margin: 0 0 0 0;
    padding: 0 2px 0 3px;
    ${media.mobileDevice`
    flex-direction:column;
    justify-content: space-between;
    /* margin-top: 20px; */
   // padding: 12px;
    background: #f5f5f7;
    padding : 10px 0px 0px 0px;
    border-top : 2px solid #ebebeb;
    `}
`;

export const Header = styled.div`
    display: flex;
    align-items: center;

    /* // padding-left: ${({ paddingLeft }) =>
        paddingLeft ? paddingLeft : '5px'}; */
    width: ${({ width }) => (width ? width : '100%')};
    height: ${({ height }) => (height ? height : '22px')};
    text-align: left;
    letter-spacing: 0px;
    opacity: 1;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '15px'};
    font-family: 'AvenirNextWorld Demi';
    justify-content: space-between;
    font-size: ${SMALL_TEXT_PX};
    color: black;
    // color: #4f4f4f;
    margin: ${({ margin }) => (margin ? margin : '0px')};
    ${media.mobileDevice`
        margin-bottom:15px ;
        /* padding-bottom: 30px; */
        padding: 0;
        // extra space removed b/w tissue service label and shipping details
        margin-top: 0px;
        // grey color applied from edge to edge
        height: ${({ mbHeight }) => mbHeight};
        
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '98%')};
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '98%')};
        margin-left:${({ marginLeft }) => marginLeft && marginLeft};
        padding-left: ${({ mbPaddingLeft }) =>
            mbPaddingLeft ? mbPaddingLeft : '5px'};
        display: ${({ mbDisplay }) => (mbDisplay ? mbDisplay : 'flex')};
    `};
`;

export const MainSectionList = styled(MainSection)`
    margin: 0px;
    padding: 0px;
`;
export const DropDownStyle = styled.div`
    margin: 0px;
    margin-bottom: 10px;
    display: flex;
    width: ${({ width }) => (width ? width : '45%')};

    ${media.mobileDevice`
         margin: 10px 0px 5px;
         margin-bottom: 18px;
         width: 100% !important;
         padding : ${({ isCondensedView }) => (isCondensedView ? '10px 10px 0px 10px' : '10px 0px 0px 0px')};
    `}
    ${media.mediumDevice`
        width: ${({ ipadwidth }) => (ipadwidth ? ipadwidth : '48%')};
        `};
`;

export const BoxStyle = {
    border: 'none',
    boxShadow: 'none',
    margin: '0px',
};
export const ContainerStyle = {
    marginTop: '0px',
};
export const BackTitle = styled.p`
    color : ${TITLE_FONT_COLOR};
    font-family: 'AvenirNextWorld Demi';
    margin: 0;
    width: ${({ width }) => (width ? width : '100%')};
    display: flex;
    cursor: pointer;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '1px')};
    font-size: ${SMALL_TEXT_PX};

    ${media.mobileDevice`
      margin: ${({ margin }) => (margin ? margin : '10px 0 0px 7px')};
        font-size: ${SMALL_TEXT_PX};
        padding: 0;
    `}
`;

export const StyledDiv = styled.div`
    color: #140f4b;
    margin: ${({ margin }) => (margin ? margin : ' 30px 0px 0px 5px')};
    font-size: ${SMALL_TEXT_PX};
    font-family:'AvenirNextWorld Regular';
    ${media.mobileDevice`
     margin:10px 0px 0px 10px;
     height: calc(100vh - 440px);
    `}
`;

export const StyledDivMessage = styled.div`
    color: #140f4b;
    margin: 10px 0px 0px 5px;
       font-size: ${SMALL_TEXT_PX};
    font-family: 'AvenirNextWorld Regular';
    ${media.mobileDevice`
     margin:10px 0px 0px 10px;
     height: calc(100vh - 440px);
    `}
`;

export const SetItemCardContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    overflow-y: scroll;
    scrollbar-width: ${({ scrollBar }) =>
        scrollBar}; // add this props to hide scroll bar 'none'
    align-content: flex-start;
    overflow-x: hidden;
    height: ${({ height }) => (height ? height : '30vh')};
    padding-bottom: 120px;

    &::-webkit-scrollbar {
        display: block;
        width: 7px;
    }
    &::-webkit-scrollbar-track {
        margin-top: 15px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #888;
        border-radius: 10px;
        height: 100px;
    }
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
        height: 600px;
    }
    ${media.mobileDevice`
        padding-bottom: 120px;
    `}
`;
export const SetItemListContainer = styled.div.attrs((props) => ({
    id: props.id || 'setItemListContainer',
}))`
    flex-wrap: wrap;
    overflow-y: scroll;
    overflow-x: hidden;
    width: 100%;
    height: ${({ isCondensedView }) =>
        isCondensedView ? '41vh' : '20vh'}; 
    padding-bottom: 2%;
    &::-webkit-scrollbar {
        display: block;
        width: 7px;
    }
    &::-webkit-scrollbar-track {
        margin-top: 15px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #888;
        border-radius: 10px;
        height: 100px;
    }
    ${media.mobileDevice`
        padding-bottom: 120px;
    `}
`;
export const VerticalLineSeperator = styled.div`
    border-left: 1px solid #ebebeb;
    height: 100%;
`;

export const ImageContainer = styled.div`
    display: flex;
    width: ${({ width }) => (width ? width : '39%')};
    justify-content: space-evenly;
    margin-left: ${({ marginLeft }) => marginLeft};
    margin-right: ${({ marginRight }) => marginRight};
    margin: ${({ margin }) => margin};
`;

export const BackAndSetItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${({ width }) => (width ? width : '70%')};
    padding-right: 20px;
    ${media.mobileDevice`
    width: 100%;
    padding-right: 0px;
    `}
`;

export const MainTableSection = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 16px;
    ${media.mobileDevice`
        flex-direction:column;
        justify-content: flex-start;
        height: 40rem;
    `}
`;
export const ActionPanelContainer = styled.div`
    display: flex;
    justify-content: space-between;
    ${media.mobileDevice`
        flex-direction:column;
        justify-content: space-between;
    `}
    ${media.largeDevice`    
        flex-wrap:wrap;
    `}
    ${media.smalDevice`    
        flex-direction:column;
        justify-content: space-between;
    `}
    .p-tabview-nav {
        ${media.mobileDevice`
            width: 350px;
        `}
        @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
            width: 295px;
        }
    }
`;
export const FilterSection = styled.div`
    width: 33%;

    ${media.largeDevice`    
        width: ${({ width }) => (width ? width : '38%')};
    `}

    ${media.mediumDevice`    
        width: 45%;
    `}
    ${media.smalDevice`    
        width: 50%;
    `}
    ${media.mobileDevice`     
        width: 100%;
    `}
`;
export const FilterContainer = styled.div`
    height: ${({ filterHeight }) =>
        filterHeight ? filterHeight : 'calc(100vh - 10.125rem)'};
    overflow-y: scroll;
    /* margin-right: 25px; */
    padding-bottom: 120px;
    &::-webkit-scrollbar {
        display: ${({ theme }) => theme.scrollOption.show};
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        margin-top: 15px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.scrollOption.thumb_color};
        border-radius: ${({ theme }) => theme.scrollOption.border_radius};
        height: 7rem;
    }

    @media screen and (min-device-width: 1360px) and (max-device-width: 1370px) and (min-device-height: 1020px) and (max-device-height: 1130px) and (orientation: landscape) {
        padding-bottom: 120px;
        height: ${(props) =>
            props.showDoubleBanner
                ? 'calc(100vh - 24.125rem)'
                : props.showSingleBanner
                ? 'calc(100vh - 21.125rem)'
                : 'calc(100vh - 18.125rem)'} !important;
    }

    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
        padding-bottom: 240px;
        height: ${(props) =>
            props.showDoubleBanner
                ? 'calc(100vh - 24.125rem)'
                : props.showSingleBanner
                ? 'calc(100vh - 21.125rem)'
                : 'calc(100vh - 18.125rem)'} !important;
    }

    @media screen and (min-device-width: 1070px) and (max-device-width: 1090px) and (min-device-height: 800px) and (max-device-height: 820px) and (orientation: landscape) {
        padding-bottom: 180px;
        height: ${(props) =>
            props.showDoubleBanner
                ? 'calc(100vh - 24.125rem)'
                : props.showSingleBanner
                ? 'calc(100vh - 21.125rem)'
                : 'calc(100vh - 18.125rem)'} !important;
    }

    ${media.mediumDevice`
        padding-bottom: 120px;
        overflow-x:hidden;
    `}

    ${media.smalDevice`
        overflow-x:hidden;
    `}

    ${media.mobileDevice`     
        height:100%;
        overflow-x:hidden;
        margin-right: 0;
        padding-bottom: 0px;
    `}
`;
export const AddedCartButton = styled.div`
    width: ${({ width }) => (width ? width : '30px')};
    height: ${({ height }) => (height ? height : '30px')};
    display: ${({ display }) => (display ? display : 'flex')};
    visibility: ${({ visibility }) => visibility};
    justify-content: center;
    align-items: center;
    border: ${({ border }) => (border ? border : '1px solid #ebebeb')};
    box-shadow: ${({ shadow }) => (shadow ? shadow : '0px 0px 2px #00000029')};
    border-radius: 6px;
    opacity: 1;
    &.disabled {
        opacity: 0.5;
        pointer-events: none;
    }
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0px')}; ;
`;
export const MainContainer = styled.div`
    overflow-y: scroll;
    overflow-x: hidden;
    background: #ffffff 0% 0% no-repeat padding-box;
    width: 100%;
    height: 800px;
    padding-top: 10px;
    ${media.largeDevice`    
    width: 100%;
    `}
    ${media.portraitDevice`    
        width: 100%;
    `}
    ${media.smalDevice`    
    width: 100%;
    `}
    ${media.mobileDevice`     
       width:calc(100vw - 32px);            
    `}
`;

export const SubContainerRows = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: ${(props) => props.padding};
    justify-content: space-between;
    /* margin-bottom: ${({ isExpanded }) => (isExpanded ? '16px' : '0px')}; */
`;

export const Container = styled.div`
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    opacity: 1;
    display: flex;
    flex: column;
`;

export const ProductCategoriesContainer = styled.div`
    margin: ${(props) => (props.margin ? props.margin : '0px')};
    ${media.mobileDevice`    
    width:100%;
`}
`;

export const ProductButtonPanelContainer = styled.div`
    margin: 10px 10px;
    ${media.mobileDevice`              
    margin: 10px auto;
    width:95%
`}
`;

export const ItemHeader = styled.div`
    display: flex;
    letter-spacing: -0.13px;
    color: #140f4b;
    opacity: 1;
    font-family: 'Avenir Next World, Demi';
    flex-direction: row;
`;

export const ActionContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
`;
export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
`;
export const SearchButtonIcon = styled.div.attrs(({ onClick }) => ({
    onclick: onClick,
}))`
    margin-left: 16px;
    ${media.mobileDevice`              
     margin-left: 27px; 
`}
`;

export const SortButtonIcon = styled.div.attrs(({ onClick }) => ({
    onclick: onClick,
}))`
    height: 30px;
    margin-left: 20px;
    ${media.mobileDevice`     
    `}
`;

export const CardTitle = styled.div`
    font-family: 'AvenirNextWorld Demi';
    color: #140f4b;
    font-size: ${(props) => (props.fontSize ? props.fontSize : '16px')};
`;

export const PanelButtonGroup = styled.div`
    display: grid;
    grid-template-columns: repeat(6, 16%);
    grid-template-rows: auto;
    column-gap: 2px;
    row-gap: 2px;
    ${media.mobileDevice`
        padding:0px;
    `}
`;

export const ProductHeader = styled.div`
    height: 62px;
    display: contents;
`;
export const ProductSection = styled.div`
    width: 65%;
    flex: auto;
    margin: 0 10px;
    ${media.largeDevice`    
        width: ${({ width }) => (width ? width : '60%')};
        margin: 0 auto;
        flex:none;
    `}
    ${media.mediumDevice`    
        width: 50%;
        margin: 0 auto;
        flex:none;
    `}
    ${media.smalDevice`    
        width: 50%;
        margin: 0 auto;
    `}
    ${media.mobileDevice`    
        width: 100%; 
        margin: 32px auto 0 auto;
    `}
`;

export const ItemTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    font-family: 'AvenirNextWorld demi';
    font-size: 12px;
    border-bottom: 1px solid #ddd;
    table-layout: fixed;
    margin-top: 2%;
`;

export const TableHeader = styled.th`
    background-color: white;
    width: ${({ width }) => width && width};
    font-weight: bold;
    text-align: left;
    border-bottom: 1px solid #ddd;
    padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : '10px')};
    padding-bottom: 3px;
    &.quantity {
        text-align: center;
    }

    ${media.mediumDevice`
    &.quantity {
        padding-right: 5px;
    }
`}
`;
export const TableData = styled.td`
    padding: ${({ padding }) => (padding ? padding : '4px 10px;')};
    line-height: 1.2rem;
    font-family: 'AvenirNextWorld Regular';
    font-size: 12px;
    width: ${({ width }) => width && width};
    //  border-bottom: ${({ borderBottom }) => borderBottom && borderBottom};

    &.quantity {
        text-align: center;
        padding-right: 10px;
    }

    &.delete {
        text-align: center;
    }

    &.description {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        padding-top: ${({ paddingTop }) => paddingTop && paddingTop};
    }

    &.product {
        color: #1010eb;
        font-family: 'AvenirNextWorld Demi';
        cursor: pointer;
        padding-top: ${({ paddingTop }) => paddingTop && paddingTop};
    }
`;

export const PaginationContainer = styled.div`
    margin-top: 12px;
    height: 48px;
    background: #f6f6f6 0% 0% no-repeat padding-box;
    box-shadow: 0px -3px 6px #00000014;
    border-radius: 4px 4px 0px 0px;
    opacity: 1;
    ${media.mobileDevice`
        flex-direction:column;
        margin: 10px 0px 0px 0px;
        box-shadow: none;
        border-radius: none;        
    `}
    ${media.smalDevice`                    
        height: auto;
        box-shadow: none;
        border-radius: none;    
    `}
    ${media.mediumDevice`    
        height: auto;
        box-shadow: none;
        border-radius: none;    
    `}
`;

export const MobileView = styled.div`
    display: none;
    ${media.mobileDevice`
        display: block;
    `}
`;

export const DesktopView = styled.div`
    display: block;
    ${media.mobileDevice`
        display: none;
    `}

    .product-guid-custom-pagination {
        position: fixed;
        width: ${({ width }) => (width ? width : '50%')};
        bottom: 0;
        ${media.mobileDevice`
            position: relative;
            width: 100%;
            bottom: 0;
        `}
    }

    #paginatorContainer {
        #paginationInfo {
            ${media.smalDevice`                    
                font-size: 12px;  
            `}
            ${media.mediumDevice`    
                font-size: 12px;
            `}
            @media screen and (min-device-width: 1360px) and (max-device-width: 1370px) and (min-device-height: 1020px) and (max-device-height: 1130px) and (orientation: landscape) {
                font-size: 12px;
                width: 45%;
                margin: 12px 12px;
            }

            @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
                font-size: 12px;
                width: 45%;
                margin: 12px 12px;
            }

            @media screen and (min-device-width: 1070px) and (max-device-width: 1090px) and (min-device-height: 800px) and (max-device-height: 820px) and (orientation: landscape) {
                font-size: 12px;
                width: 40%;
                margin: 12px 8px;
            }

            @media only screen and (min-width: 1110px) and (max-width: 1122px) and (orientation: landscape) {
                font-size: 12px;
                width: 45%;
                margin: 12px 12px;
            }
        }
        .p-paginator {
            @media screen and (min-device-width: 1070px) and (max-device-width: 1090px) and (min-device-height: 800px) and (max-device-height: 820px) and (orientation: landscape) {
                padding: 0.5rem 0.5rem;
            }
        }
    }
`;

export const PaginationContainerMobile = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px;
    width: 90%;
    ${media.mobileDevice`
        flex-direction:column;
        margin: 10px 0px 0px 0px;
        justify-content: space-between;
        position: sticky;
        bottom:0;
    `}
`;

export const ActionButton = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-around;
`;
export const AddCartIcon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: ${({ width }) => (width ? width : '14px')};
    height: ${({ height }) => (height ? height : '14px')};
    cursor: pointer;
`;
export const AddedText = styled.div`
    color: #14853d;
    font-family: 'AvenirNextWorld Regular';
    font-size: 11px;
    margin-right: 10px;
`;

export const Circle = styled.div`
    display: flex;
    align-items: center;
    width: 12px;
    height: 11px;
    border: 1px solid;
    border-radius: 50%;
    justify-content: center;
    color: #00000080;
    margin-left: 0.5%;
`;
export const Title = styled.div`
    text-align: left;
    font-family: ${({ isRegular, isDemi }) =>
        isRegular
            ? 'AvenirNextWorld Regular'
            : isDemi && 'AvenirNextWorld Demi'};
    font-size: ${({ isDemi }) => (isDemi ? '14px' : '15px')};
    color: #202124;
    opacity: 1;
`;
export const SetCount = styled.div`
    color: #000000;
    font-family: 'AvenirNextWorld Regular';
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0px')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '12px')};
`;
export const Type = styled.div`
    background: #ebebeb 0% 0% no-repeat padding-box;
    border-radius: 10px;
    display: inline;
    padding-left: 6px;
    padding-right: 6px;
    margin-left: 5px;
    color: #140f4b;
    font-size: ${({ typeFontSize }) => (typeFontSize ? typeFontSize : '12px')};
    text-align: center;
`;

export const DivPadding = styled.div`
    padding: ${({ padding }) => (padding ? padding : '0px')};
    padding-bottom: ${({ paddingBottom }) =>
        paddingBottom ? paddingBottom : ''};
`;
export const TableRow = styled.tr`
    height: 10px;
    &:nth-child(even) {
        background-color: #f5f5f5cc;
    }

    &:nth-child(odd) {
        background-color: white;
    }
`;

export const MainWrapper = styled.div.attrs((props) => ({
    id: props.id || 'setItemDetails-mainWrapper',
}))`
    background-color: ${({ isCondensedView }) =>
        isCondensedView ? 'white' : 'none'};
        z-index: 100;

        ${media.mediumDevice`
            height: 50vh;
        `}
`;

export const HeaderFlexContainer = styled.div.attrs((props) => ({
    id: props.id || 'setItemDetails-header-flex-container',
}))`
    display: flex;
    flex-direction: 'row';
    ${media.mobileDevice`
        flex-direction:column;
    `}
`;
export const MarginAutoDiv = styled.div`
    width: '50%';
    margin: 'auto';
    text-align: 'center';
`;

export const ImageContainerStyled = styled.div`
    margin-right: 8px;
    margin-left: ${({ singleImage }) => (singleImage ? '-35px' : '0')};
    width: ${({ width }) => width || 'auto'};
`;

export const PaddingDiv = styled.div`
    padding: ${({ padding }) => padding || '0px'};
    padding-bottom: ${({ paddingBottom }) => paddingBottom || '0px'};
`;

export const ProductImagesDisplayMain = styled.div.attrs((props) => ({
    id: props.id || 'product-images-display-main',
}))`
    width: '50%';
    margin: 'auto';
    text-align: 'center';
`;
